import { connect } from "react-redux"
import { compose } from "ramda"

import Router from "./router.jsx"
import { withStaticProps } from "@cirrus/legacy/framework"

export default ({ getLocation, onLocationChanged }) =>
  compose(
    withStaticProps({
      getLocation,
    }),
    connect(undefined, (dispatch) => {
      return {
        onLocationChanged: onLocationChanged(dispatch),
      }
    }),
  )(Router)
